<template>
  <modal name="securone-edit-document" class="modal-inner" transition="pop-out" :width="600" height="auto" :adaptive="true" :scrollable="true" :focus-trap="true" @before-close="reset">
    <span class="close-button" @click="$modal.hide('securone-edit-document')"><BaseIcon icon="times-circle" class="text-white" /></span>
    <div class="modal-header text-lg font-serif">{{ $t("securone.documents.edit_title") }}</div>
    <div class="modal-body" v-if="document">
      <ValidationObserver ref="form">
        <div class="py-2"><BaseInput v-model="form.title" :field_name="$t('securone.documents.name')" rules="required" /></div>
      </ValidationObserver>
      <LevelPicker v-model="level" class="mt-2" />
      <SoNote tone="muted" class="mt-3">{{ $t("securone.documents.edit_note", { v: document.currentVersion }) }}</SoNote>
      <SoNote v-if="error" tone="bad" class="mt-3">{{ error }}</SoNote>
    </div>
    <div class="modal-footer">
      <div class="footer-container clearfix">
        <button class="sd-btn sd-btn--secondary float-left" @click="$modal.hide('securone-edit-document')">{{ $t("securone.common.cancel") }}<BaseIcon icon="times-circle" class="ml-1" /></button>
        <button class="sd-btn sd-btn--success float-right" :disabled="busy" @click="submit">{{ $t("securone.common.save") }}<BaseIcon icon="save" class="ml-1" /></button>
      </div>
    </div>
  </modal>
</template>

<script>
import SoNote from "./SoNote.vue";
import LevelPicker from "./LevelPicker.vue";
import api from "../securone.api";
import { errorMessage } from "../securone.helpers";

export default {
  name: "EditDocumentModal",
  components: { SoNote, LevelPicker },
  data() {
    return { document: null, form: { title: "" }, level: { level: "departments", departmentIds: [] }, busy: false, error: null };
  },
  methods: {
    open(document) {
      this.reset();
      this.document = document;
      this.form = { title: document.title };
      this.level = { level: document.level, departmentIds: (document.departmentIds || []).map(String) };
      this.$modal.show("securone-edit-document");
    },
    reset() {
      this.busy = false;
      this.error = null;
    },
    async submit() {
      if (!(await this.$refs.form.validate())) return;
      if (this.level.level === "departments" && !this.level.departmentIds.length) {
        this.error = this.$t("securone.department.required");
        return;
      }
      this.busy = true;
      this.error = null;
      try {
        const updated = await api.updateDocument(this.document._id, { title: this.form.title, level: this.level.level, departmentIds: this.level.departmentIds });
        this.$modal.hide("securone-edit-document");
        this.$emit("saved", updated);
      } catch (error) {
        this.error = errorMessage(this, error);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
